import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=f36d1022&scoped=true&"
import script from "./addCategory.vue?vue&type=script&lang=js&"
export * from "./addCategory.vue?vue&type=script&lang=js&"
import style0 from "./addCategory.vue?vue&type=style&index=0&id=f36d1022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36d1022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f36d1022')) {
      api.createRecord('f36d1022', component.options)
    } else {
      api.reload('f36d1022', component.options)
    }
    module.hot.accept("./addCategory.vue?vue&type=template&id=f36d1022&scoped=true&", function () {
      api.rerender('f36d1022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/addCategory.vue"
export default component.exports